import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline';
import {
  Box,
  Button,
  Chip,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Grid,
  IconButton,
  Link,
  Paper,
  styled,
  Tooltip,
  Typography,
  Menu,
  MenuItem
} from '@mui/material';
import PropTypes from 'prop-types';
import { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import { cloudinaryThumbnail, cloudinaryFull } from '../../../../utils/formatCloudinary';
import { addItemToCart, clearBadgeFromRedux, removeItemFromCart } from '../../../../redux/slices/rentals';
import { useDispatch, useSelector } from '../../../../redux/store';
import Iconify from '../../../../reusable-components/iconify';
import Image from '../../../../reusable-components/image';
import Lightbox from '../../../../reusable-components/lightbox';
import { getAllCartsItemsCount } from '../../../../redux/slices/orderSheet';

RentalItem.propTypes = {
  item: PropTypes.object,
  orderId: PropTypes.number,
  setItemsToAdd: PropTypes.func,
  setIsBouncing: PropTypes.func,
  isExistingOrder: PropTypes.bool,
  cartId: PropTypes.number
};

export default function RentalItem({ item, orderId, setItemsToAdd, setIsBouncing, isExistingOrder, cartId }) {
  const dispatch = useDispatch();
  const { user } = useSelector((state) => state.user);
  const [openNotPreferredDialog, setOpenNotPreferredDialog] = useState(false);
  const [anchorEl, setAnchorEl] = useState(null);
  const [selectedPricingTypeId, setSelectedPricingTypeId] = useState(null);
  const location = useLocation();
  const residentId = Number(new URLSearchParams(location.search).get('residentId'));

  const CustomIconButton = styled(Iconify)({
    cursor: 'pointer',
    color: '#fff',
  });

  const addToCart =  (e, pricingId) => {
    e.preventDefault();
    e.stopPropagation();
    setAnchorEl(null);
    handleClickAddToCart(pricingId);
  }

  const handleClickAddToCart = (pricingId) => {
    setSelectedPricingTypeId(pricingId);
    if (!item.isPreferred) {
      setOpenNotPreferredDialog(true);
    } else {
      handleAddCart(pricingId);
    }
  };

  const handleAddCart = (pricingId) => {
    setIsBouncing(true);
    setTimeout(() => setIsBouncing(false), 300);
    if(orderId !== null || isExistingOrder){
      setItemsToAdd((prevItems) => {
        const existingItem = prevItems.find(i => item.itemId === i.itemId);
        if (existingItem) {
          return prevItems.map(i => i.itemId === item.itemId ? { ...i, quantity: i.quantity + 1 } : i);
        }
        return ([...prevItems, { itemId: item.itemId, residentId, userId: user.id, quantity: 1, pricingTypeId: pricingId, description: item.description }]);
    });
    } 
    else {
    dispatch(addItemToCart(item.itemId, residentId, user.id, cartId ?? 0, pricingId)).then(() => dispatch(getAllCartsItemsCount()));
    setTimeout(() => {
      dispatch(clearBadgeFromRedux());
    }, 1000);}
  };

  const handleRemoveCart = () => {
    setIsBouncing(true);
    setTimeout(() => setIsBouncing(false), 300);
     if(orderId !== null || isExistingOrder){
      setItemsToAdd((prevItems) => {
        const existingItem = prevItems.find(i => item.itemId === i.itemId);
        if (existingItem?.quantity > 1) {
          return prevItems.map(i => i.itemId === item.itemId ? { ...i, quantity: i.quantity - 1 } : i);
        }
        return ([...prevItems.filter(i => i.itemId !== item.itemId)]);
    });
    } 
    else {
      dispatch(removeItemFromCart(item.cartItemId)).then(() => dispatch(getAllCartsItemsCount()));
    }
  };

  const [selectedImage, setSelectedImage] = useState(-1);
  const handleOpenLightbox = () => {
    setSelectedImage(0);
  };

  const handleCloseLightbox = () => {
    setSelectedImage(-1);
  };

  const handleClose = () => {
    setOpenNotPreferredDialog(false);
    setSelectedPricingTypeId(null);
  };
  const handleConfirm = () => {
    setOpenNotPreferredDialog(false);
    handleAddCart(selectedPricingTypeId);
    setSelectedPricingTypeId(null);
  };
  return (
    <Grid item key={item} xs={3} style={{ maxWidth: '300px' }}>
      <Paper
        key={item.itemId}
        elevation={12}
        sx={{
          textAlign: 'left',
          cursor: 'pointer',
          position: 'relative',
          padding: '4px',
          width: '200px',
          height: '310px',
          display: 'flex',
          flexDirection: 'column',
        }}
      >
        {item?.quantity > 0 ? 
          <div style={{ padding: '20px' }}>
            <AddToCartDiv>
              <CustomIconButton icon="lucide:trash" width={12} height={12} onClick={() => handleRemoveCart()} />
              <span>&nbsp;&nbsp;</span>
              <span style={{ color: '#fff' }}>{item.quantity}</span>
              <span>&nbsp;&nbsp;</span>{' '}
              <CustomIconButton
                icon="iconamoon:sign-plus-bold"
                width={12}
                height={12}
                onClick={() => handleClickAddToCart()}
              />
            </AddToCartDiv>
          </div>
        : 
           item?.pricingTypes?.length > 0 ? 
           <>
            <IconButton
            onClick={(event) => setAnchorEl(event.currentTarget)}
            sx={{
              right: -20,
              top: -6,
              ml: 15,
              position: 'relative',
              color: 'secondary.main',
            }}
          >
            <Iconify icon="iconamoon:sign-plus-circle-fill" width={24} height={24} />
         </IconButton>
            <Menu anchorEl={anchorEl} open={Boolean(anchorEl)} onClose={() => setAnchorEl(null)}>
               <MenuItem
                    onClick={(e) => {
                      addToCart(e, item.pricingTypeId);
                    }}
                  >
                   ${Number(item.price).toFixed(2)}/{item.pricingTypeName}
                </MenuItem>
              { item?.pricingTypes?.map((pricingType) => (
                 <MenuItem
                    key={pricingType.pricingType || pricingType.pricingTypeName}
                    onClick={(e) => {
                      addToCart(e, pricingType.pricingType);
                    }}
                  >
                  ${Number(pricingType.price).toFixed(2)}/{pricingType.pricingTypeName}
                </MenuItem>)
                )}
            </Menu>
            </>
           : 
          <IconButton
            onClick={() => { handleClickAddToCart( item.pricingTypeId)}}
            sx={{
              right: -20,
              top: -6,
              ml: 15,
              position: 'relative',
              color: '#b128bc',
            }}
          >
            <Tooltip title={`Add to Cart`}>
              <Iconify icon="iconamoon:sign-plus-circle-fill" width={24} height={24} />
            </Tooltip>
          </IconButton>
        }
        <Image
          alt="attachment"
          src={
            item.image ||
            cloudinaryThumbnail(
              'https://res.cloudinary.com/agoraserv/image/upload/v1738258682/No%20Image%20Animation.gif'
            )
          }
          sx={{
            borderRadius: 1.5,
            width: '80%',
            height: 'auto',
            maxHeight: '140px',
            minHeight: '140px',
            objectFit: 'contain',
            margin: '0 auto',
            display: 'block',
          }}
          onClick={() => handleOpenLightbox()}
        />
        <Lightbox
          slides={[
            {
              src:
                item.image ||
                cloudinaryFull(
                  'https://res.cloudinary.com/agoraserv/image/upload/v1738258682/No%20Image%20Animation.gif'
                ),
            },
          ]}
          open={selectedImage >= 0}
          close={handleCloseLightbox}
        />

        {item.isPreferred && (
          <Chip
            label="Preferred"
            color="info"
            variant="outlined"
            size="small"
            icon={<CheckCircleOutlineIcon sx={{ fontSize: 14 }} />}
            sx={{
              mt: 2,
              mb: 1,
              fontSize: '12px',
              height: 20,
              padding: '0 6px',
              width: '110px',
              justifyContent: 'flex-start',
              textAlign: 'left',
              '& .MuiChip-icon': {
                marginLeft: 0,
                marginRight: '4px',
              },
            }}
          />
        )}
        <Box
          sx={{
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'left',
            maxWidth: '200px',
            marginTop: 'auto',
          }}
        >
          <Typography variant="subtitle2">
            <span style={{ fontWeight: 'bold', fontSize: '14px' }}>${Number(item.price).toFixed(2)}</span>
            <span>/</span>
            <span>{item.pricingTypeName}</span>
          </Typography>
          <Typography variant="subtitle2">
            {item.vendorName} {item.vendorItemId}
          </Typography>
          <div style={{ display: 'flex', flexWrap: 'wrap' }}>
            {item.vendorUrl ?  
            <Tooltip title={`Proceed to Vendor Site`}>
              <Typography variant="subtitle2">
                <Link
                  href={item.vendorUrl}
                  variant="inherit"
                  target="_blank"
                  style={{
                    fontSize: '12px',
                    textDecoration: 'bold',
                    overflow: 'hidden',
                    textOverflow: 'ellipsis',
                  }}
                >
                  {' '}
                  {item.description}
                </Link>
              </Typography>
            </Tooltip> :
             <Typography variant="inherit" sx={{ fontSize: '12px', fontWeight: 'bold',cursor: 'default', color: 'primary.main', textDecoration: 'bold',}}>
                {' '}
                {item.description}
              </Typography>
            }
           
          </div>
        </Box>
      </Paper>

      {openNotPreferredDialog && (
        <div>
          <Dialog
            open={openNotPreferredDialog}
            onClose={(event, reason) => {
              if (reason === 'backdropClick' || reason === 'escapeKeyDown') return;
              handleClose();
            }}
            aria-labelledby="confirm-dialog-title"
            aria-describedby="confirm-dialog-description"
          >
            <DialogTitle id="confirm-dialog-title" sx={{ textAlign: 'center' }}>
              Not Preferred Vendor
            </DialogTitle>
            <DialogContent>
              <DialogContentText id="confirm-dialog-description">
                Are you sure you want to continue with this non-preferred vendor?
              </DialogContentText>
            </DialogContent>
            <DialogActions>
              <Button onClick={handleClose} color="primary">
                Cancel
              </Button>
              <Button onClick={handleConfirm} color="primary" variant="contained" autoFocus>
                Yes
              </Button>
            </DialogActions>
          </Dialog>
        </div>
      )}
    </Grid>
  );
}
const AddToCartDiv = styled('div')(({ theme }) => ({
  position: 'absolute',
  right: 0,
  top: 7,
  height: 22,
  borderRadius: '10px',
  backgroundColor: '#b128bc',
  color: 'secondary',
  padding: theme.spacing(0.5),
  margin: '2.5px 3px 2.5px 0',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
  zIndex: '2',
}));
